// src/context/AuthContext.jsx
// Customer-facing auth removed. This stub satisfies all existing imports.
import React, { createContext, useContext } from 'react';

const AuthContext = createContext(null);

const noop = async () => {};

export const AuthProvider = ({ children }) => (
  <AuthContext.Provider
    value={{
      user: null,
      loading: false,
      error: null,
      isAuthenticated: false,
      signOut: noop,
      clearError: noop,
    }}
  >
    {children}
  </AuthContext.Provider>
);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
};
